import { createContext, useContext, useState, useEffect } from "react";
import { createUserWithEmailAndPassword, updateProfile, onAuthStateChanged, signInWithEmailAndPassword, signOut, sendPasswordResetEmail } from "firebase/auth"
import { auth } from "../firebase"
import { getAuth, deleteUser } from "firebase/auth";





const UserContext = createContext({})

export const useUserContext = () => useContext(UserContext)

export const UserContextProvider = ({ children }) => {

    const [user, setUser] = useState(null)
    const [loading, setLoading] = useState();
    const [error, setError] = useState("");

    useEffect(() => {
      setLoading(true)
      const unsubscribe = onAuthStateChanged(auth, res => {
        res ? setUser(res) : setUser(null)
        setError("");
        setLoading(false)
      })
      return unsubscribe
    }, [])
    

    const registerUser = (email, name, password) => {
        setLoading(true)
        createUserWithEmailAndPassword(auth, email, password)
            .then(() => {
                return updateProfile(auth.currentUser, {
                    displayName: name
                })
            })
            .then(res => console.log(res))
            .catch(err => setError(err.message))
            .finally(() => setLoading(false))

    }

    const signInUser = (email, password) => {
        setLoading(true)
        signInWithEmailAndPassword(auth, email, password)
        .then(res => console.log(res))
        .catch(err => setError(err.message))
        .finally(() => setLoading(false))
    }

    const logoutUser = () => {
        signOut(auth);
    }

    function DeleteUser() {
        const auth = getAuth();
        const user = auth.currentUser;
        
        deleteUser(user).then(() => {
          // User deleted.
        }).catch((error) => {
          // An error ocurred
        });
    }

    const forgotPassword = (email) => {
        return sendPasswordResetEmail(auth, email)
    }    

    const contextValue = {
        user,
        loading,
        error,
        registerUser,
        signInUser,
        logoutUser,
        DeleteUser,
        forgotPassword,
        
    }

    return (
    <UserContext.Provider value={contextValue}>
        {children}
    </UserContext.Provider>
    
    )
}